import React from "react";

import { StyledSVG } from "../StyledIcon";

export const CareersIcon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 48 48"
      fill="none"
      {...props}
    >
      <path
        d="M4.82609 30.3913L6.17557 39.1565C6.3066 40.0202 6.74287 40.8083 7.40523 41.3779C8.0676 41.9474 8.91217 42.2607 9.78574 42.2608H38.2143C39.0878 42.2607 39.9324 41.9474 40.5948 41.3779C41.2571 40.8083 41.6934 40.0202 41.8244 39.1565L43.1739 30.3913C43.6582 30.3913 44.1227 30.1989 44.4652 29.8564C44.8076 29.514 45 29.0495 45 28.5652V16.6956C45 15.727 44.6152 14.7981 43.9303 14.1132C43.2454 13.4282 42.3164 13.0435 41.3478 13.0435H6.65217C5.68356 13.0435 4.75461 13.4282 4.0697 14.1132C3.38478 14.7981 3 15.727 3 16.6956V28.5652C3 29.0495 3.19239 29.514 3.53485 29.8564C3.87731 30.1989 4.34178 30.3913 4.82609 30.3913Z"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M32.2174 13.0435H15.7826V11.2174C15.7826 9.76447 16.3598 8.37105 17.3872 7.34368C18.4145 6.31631 19.808 5.73914 21.2609 5.73914H26.7391C28.1921 5.73914 29.5855 6.31631 30.6129 7.34368C31.6402 8.37105 32.2174 9.76447 32.2174 11.2174V13.0435Z"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M4.82608 30.3913H20.3478"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M27.6522 30.3913H43.1739"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M24 34.9565C26.0171 34.9565 27.6522 32.9126 27.6522 30.3913C27.6522 27.87 26.0171 25.8261 24 25.8261C21.983 25.8261 20.3478 27.87 20.3478 30.3913C20.3478 32.9126 21.983 34.9565 24 34.9565Z"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />
    </StyledSVG>
  );
};
